<!--
 * @Author: qiuwenjing qiuwenjing@vip56.cn
 * @Date: 2024-05-11 10:26:06
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2026-02-09 11:04:24
 * @FilePath: \projectManagementFrontd:\project\app\PosGarmentMerchant-Front\src\views\home\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="returnResultPanel_main">
        <van-overlay :show="show" :lock-scroll="false">
            <div class="dm_form_box" >
                 <div class="icon_pay">
					<img class="img_pay"  src="@/assets/padImg/pay_w.png" v-if="returnInfo.paymentMethod==3" />
					<img class="img_pay"  src="@/assets/padImg/pay_a.png" v-if="returnInfo.paymentMethod==4" />
					<img class="icon_result" src="@/assets/padImg/wait.png" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2" />
					<img class="icon_result" src="@/assets/padImg/slsuccess.png" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==1" />
					<img class="icon_result" src="@/assets/padImg/slfail.png" v-if="!returnInfo.success&&num>0" />
					<img class="icon_result" src="@/assets/padImg/slclose.png" v-if="(!returnInfo.success&&num<=0)||(returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3)" />
				 </div>
				 <div v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2&&returnInfo.paymentMethod==3">
					 <div class="tit">退款申请已受理成功</div>
					 <div class="txt">微信已接收退款请求, 正在处理中...</div>
					 <div class="tip">零钱/零钱通退款，约20分钟内到账；银行卡约1-7个工作日(以银行为准)</div>
				 </div>
				 <div v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2&&returnInfo.paymentMethod==4">
					 <div class="tit">退款申请已受理成功</div>
					 <div class="txt">支付宝已接收退款请求, 正在处理中...</div>
					 <div class="tip">余额/余额宝实时到账；银行卡预计约1-7个工作日到账(以银行为准)</div>
				 </div>
				 <div v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==1">
					 <div class="tit">退款成功</div>
					 <div class="txt">实退金额：{{fmoney(returnInfo.returnPrice)}}  退款到账时间：{{returnInfo.refundInfo.successTime}}</div>
					 <div class="tip" v-if="returnInfo.paymentMethod==3&&returnInfo.refundInfo.refundRecvAccout">退款入账账户：{{returnInfo.refundInfo.refundRecvAccout}}</div>
				 </div>
				  <div class="tit" v-if="!returnInfo.success">退款申请受理失败</div>
				  <div class="tit" v-if="num<=0||(returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3)">本次退款已关闭！</div>
				<div class="info_box">
					<div class="fail_result" v-if="!returnInfo.success&&returnInfo.error">
						{{returnInfo.error}}
					</div>
					<div class="fail_result" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3&&returnInfo.refundInfo.error">
						{{returnInfo.refundInfo.error}}
					</div>
					<div class="ib_tip" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2">
						<img class="icon_tip" src="@/assets/padImg/wait2.png" />
						<span>您可进入: 报表--销售报表--异常退货订单查询退款进度</span>
					</div>
					<div class="ib_tip" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==1">
						<img class="icon_tip" src="@/assets/padImg/wait2.png" />
						<span>报表--销售报表--退货订单查看退货订单详情</span>
					</div>
					<div class="ib_tip" v-if="!returnInfo.success||(returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3)">
						<img class="icon_tip" src="@/assets/padImg/wait2.png" />
						<span>您可以在报表--销售报表--异常退货订单查看失败原因详情</span>
					</div>
					<div class="ib_line">
						<span class="label">退货订单号</span>
						<span class="val">{{returnInfo.returnOrderNo}}</span>
					</div>
					<div class="ib_line">
						<span class="label">应退金额</span>
						<span class="val">{{fmoney(returnInfo.returnPrice)}}</span>
					</div>
				</div>
				<div class="btn_group">
					<div class="btn" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2" @click="onClose">点击关闭，该操作不会影响当前的退款操作</div>
					<div class="btn" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==1" @click="onClose">我知道了</div>
					<div class="btn btn2" v-if="!returnInfo.success&&num>0" @click="closeOrder">关闭</div>
					<div class="btn btn2" v-if="(!returnInfo.success&&num<=0)||(returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3)" @click="onClose">关闭</div>
					<div class="btn btn2" v-if="!returnInfo.success||(returnInfo.refundInfo.status&&returnInfo.refundInfo.status==3)" @click="changeReturnMethod">更改退款方式</div>
					<div class="btn btn3" v-if="!returnInfo.success&&num>0" @click="returnAgain">重新发起({{num}}次)</div>
					<div class="bg_tip" v-if="returnInfo.refundInfo.status&&returnInfo.refundInfo.status==2">关闭后请进入[异常退货订单]手动查询退款结果</div>
				</div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {fmoney} from '@/common/money';
import calculate from '@/common/util/calculate';
export default{
    components:{
	},
	props:{
		show:{
			type:Boolean,
			default:false
		},
		form:{
			type:Object,
			default:()=>{}
		},
		isloading:{
			type:Boolean,
			default:false
		},
	},
	data(){
		return{
			returnInfo:{},
			fmoney:fmoney,
			num:3,
			timeOut:null,
		}
	},
	computed:{
	},

    created() {
    },

    mounted() {
       this.onRefresh();
    },
	methods:{
		onClose(){
			this.onClearTime();
			this.$emit('onClose');
		},
		closeOrder(){
			if(this.isloading) return;
			this.onClearTime();
			this.$emit('closeOrder');
		},
		changeReturnMethod(){
			if(this.isloading) return;
			this.onClearTime();
			let needClose = this.num>0&&!this.returnInfo.success;
			this.$emit('changeReturnMethod',needClose);
		},
		returnAgain(){
			if(this.isloading) return;
			this.onClearTime();
			this.$emit('returnAgain');
			this.num=this.num-1;
			if(this.num<=0){
				this.onClose();
			}
		},
		onClearTime(){
			if(this.timeOut){
			   clearInterval(this.timeOut);
			}
		},
		onRefresh(){
			this.returnInfo = this.form;
			if(this.returnInfo.refundInfo.status!=2){
				this.onClearTime();
			}else{
				if(this.returnInfo.refundInfo.status&&this.returnInfo.refundInfo.status==2){
					   this.onClearTime();
					   this.timeOut = setInterval(()=>{
						   this.$emit('refreshStatus');
					   },6000)
				}
			}
		}
	}




}
</script>

<style lang="scss" scoped>
@function px2vw($n) {
	@return ($n / 1366 * 100) * 1vw;
}
.returnResultPanel_main{
    position: fixed;
    z-index: 99;
	font-size: px2vw(12);
    .dm_form_box{
        width: px2vw(640);
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border-radius: 0.29vw;
        min-height: px2vw(540);
        background: linear-gradient(179deg, #FFF9EC 0%, #F7F8FA 31%);
		box-sizing: border-box;
		padding-top: px2vw(40);
		.icon_pay{
			width: px2vw(55);
			height: px2vw(55);
			position: relative;
			margin: 0 auto;
			margin-bottom: px2vw(19);
			.img_pay{
				width: 100%;
				height: 100%;
			}
			.icon_result{
				width: px2vw(28);
				height: px2vw(28);
				position: absolute;
				right: -1.02vw;
				bottom: -0.37vw;
				border: 2px solid #fff;
				border-radius: 50%;
			}
		}
		.tit{
			text-align: center;
			font-size: px2vw(18);
			line-height: px2vw(20);
			letter-spacing: 0px;
			color: #1A1A1A;
			margin-bottom: px2vw(16)
		}
		.txt{
			font-size: px2vw(20);
			line-height: px2vw(20);
			letter-spacing: 0px;
			color: #1A1A1A;
			margin-bottom: px2vw(8);
			text-align: center;
		}
		.tip{
			font-size: px2vw(14);
			line-height: px2vw(24);
			text-align: center;
			letter-spacing: 0px;
			color: #4E5969;
			margin-bottom: px2vw(16);
		}
		.info_box{
			width: px2vw(480);
			background: #fff;
			border-radius: px2vw(4);
			box-sizing: border-box;
			padding: px2vw(14);
			margin: 0 auto;
			.fail_result{
				font-size: px2vw(14);
				font-weight: normal;
				line-height: px2vw(24);
				letter-spacing: 0px;
				color: #1A1A1A;
				padding-bottom: px2vw(10);
				margin-bottom: px2vw(15);
				border-bottom: 1px solid #F7F8FA;
			}
			.ib_tip{
				width: 100%;
				height: px2vw(40);
				border-radius: px2vw(6);
				background: #F8F4ED;
				display: flex;
				align-items: center;
				padding-left: px2vw(8);
				box-sizing: border-box;
				font-size: px2vw(16);
				letter-spacing: 0px;
				color: #CEB57D;
				margin-bottom: px2vw(20);
				.icon_tip{
					width: px2vw(24);
					height: px2vw(24);
					display: block;
					margin-right: px2vw(6);
				}
			}
			.ib_line{
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: px2vw(16);
				line-height: px2vw(20);
				margin-bottom: px2vw(20);
				&:last-child{
					margin-bottom: 0;
				}
				.label{
					color: #4E5969;
				}
				.val{
					color: #1A1A1A;
				}
			}
		}
		.btn_group{
			margin-top: px2vw(72);
			display: flex;
			justify-content: center;
			position: relative;
			.bg_tip{
				width: 100%;
				position: absolute;
				top: px2vw(60);
				left: 0;
				text-align: center;
				font-size: px2vw(12);
				color: #FF2F36;
			}
			.btn{
				width: px2vw(340);
				height: px2vw(56);
				border-radius: px2vw(4);
				background: #CEB57D;
				font-size: px2vw(16);
				font-weight: bold;
				line-height: px2vw(56);
				text-align: center;
				letter-spacing: 0px;
				color: #FFFFFF;
				&.btn2{
					width: px2vw(151);
					border: 1px solid #CEB57D;
					color: #CEB57D;
					background: transparent;
					margin-right: px2vw(21);
				}
				&.btn3{
					width: px2vw(151);
				}
				&.btn4{
					width: px2vw(230);
				}
			}
		}
    }
}

::-webkit-scrollbar {
    display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/padViews/cashier/components/returnResultPanel.vue